import { BrowserRouter, Routes, Route } from 'react-router-dom'
import ScannerPage from './pages/ScannerPage'
import ResultsPage from './pages/ResultsPage'
import SettingsPage from './pages/SettingsPage'
import PrivacyPage from './pages/PrivacyPage'
import TermsPage from './pages/TermsPage'
import BottomNav from './components/BottomNav'
import Footer from './components/Footer'
import CookieConsent from './components/CookieConsent'
import { useAndroidShell } from './hooks/useAndroidShell'

// Inside the router, because the shell's back button and deep links both
// navigate.
function Shell() {
  useAndroidShell()

  return (
    <div
      className="min-h-screen bg-canvas text-fg"
      style={{ paddingBottom: 'calc(3.5rem + env(safe-area-inset-bottom, 0px))' }}
    >
      <Routes>
        <Route path="/results/:ean" element={<ResultsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/privatnost" element={<PrivacyPage />} />
        <Route path="/uvjeti" element={<TermsPage />} />
        <Route path="*" element={<ScannerPage />} />
      </Routes>
      <Footer />
      <BottomNav />
      <CookieConsent />
    </div>
  )
}

function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  )
}

export default App
